import { jsx as n, jsxs as y } from "react/jsx-runtime";
import { useState as v, useEffect as N, createContext as P, useContext as R } from "react";
const D = ({
  path: t,
  onClick: e,
  width: s = 512,
  height: c = 512,
  style: r,
  className: l = "night-and-day--icon",
  fill: o = "currentColor"
}) => /* @__PURE__ */ n(
  "svg",
  {
    "aria-hidden": "true",
    focusable: "false",
    className: l,
    style: r,
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: `0 0 ${s} ${c}`,
    onClick: e,
    children: /* @__PURE__ */ n("path", { d: t, fill: o })
  }
), V = (t) => /* @__PURE__ */ n(
  D,
  {
    path: "M289,23C160,23 56,127 56,256C56,385 160,489 289,489C352,489 409,464 451,423C456,418 457,411 454,404C451,397 444,394 436,395C426,397 416,397 405,397C304,397 222,316 222,214C222,146 260,86 315,55C322,51 325,44 323,37C322,30 316,25 309,24C302,23 295,23 289,23L289,23Z",
    ...t
  }
), T = ({
  Icon: t,
  caption: e,
  onClick: s,
  iconClass: c,
  iconStyle: r,
  captionStyle: l,
  className: o = "night-and-day--switcher",
  captionClass: C = "night-and-day--caption",
  style: d = { display: "inline-block" }
}) => /* @__PURE__ */ y("div", { className: o, onClick: s, style: d, children: [
  /* @__PURE__ */ n(t, { style: r, className: c }),
  !!e && /* @__PURE__ */ n("div", { className: C, style: l, children: e })
] }), Z = (t) => {
  const { setDark: e } = f();
  return /* @__PURE__ */ n(
    T,
    {
      Icon: V,
      onClick: e,
      ...t
    }
  );
}, $ = (t) => /* @__PURE__ */ n(
  D,
  {
    path: "M362,1.2C367,3 370,8 371,13L391,121L499,141C504,142 509,145 511,150C512,155 512,161 509,166L447,256L509,346C512,351 512,357 511,362C509,367 504,370 499,371L391,391L371,499C370,504 367,509 362,511C357,512 351,512 346,509L256,447L166,509C161,512 156,512 151,511C146,509 142,504 141,499L121,391L13,371C8,370 3,367 1,362C0,356 0,351 3,346L65,256L3,166C0,161 0,156 1,151C3,146 8,142 13,141L121,121L141,13C142,8 146,3 151,1C156,0 161,0 166,3L256,65L346,3C351,0 357,0 362,1ZM160,256C160,203 203,160 256,160C309,160 352,203 352,256C352,309 309,352 256,352C203,352 160,309 160,256ZM384,256C384,186 326,128 256,128C186,128 128,186 128,256C128,326 186,384 256,384C326,384 384,326 384,256Z",
    ...t
  }
), j = (t) => {
  const { setLight: e } = f();
  return /* @__PURE__ */ n(
    T,
    {
      Icon: $,
      onClick: e,
      ...t
    }
  );
}, g = "dark", u = "light", B = "(prefers-color-scheme: dark)";
function b(t) {
  return typeof t == "string";
}
function h() {
}
function A() {
  return Intl.DateTimeFormat().resolvedOptions().locale;
}
A();
const F = () => {
  let t = {};
  return {
    clear: () => t = {},
    getItem: (e) => t[e],
    setItem: (e, s) => t[e] = s,
    removeItem: (e) => delete t[e]
  };
}, I = typeof window < "u", L = I && window.localStorage ? window.localStorage : F(), w = I && window.matchMedia ? (t) => window.matchMedia(t) : null, i = w && w(B), G = () => i ? i.matches : null, O = (t) => t.split(" "), p = (t, e = "") => `${t} ${e}`, U = {
  isDark: !1,
  isLight: !0,
  setDark: h,
  setLight: h,
  setIsDark: h,
  toggleTheme: h,
  theme: u,
  variant: "",
  setVariant: h
}, z = ({
  storageKey: t,
  defaultVariant: e,
  children: s
}) => {
  const c = t ? L.getItem(t) : null, [r, l = ""] = b(c) ? O(c) : [G(), null], [o, C] = v(r === g), [d, x] = v(l || e), m = (a) => {
    C(a), t && L.setItem(
      t,
      p(a ? g : u, d)
    );
  }, M = (a) => {
    x(a), t && L.setItem(
      t,
      p(o ? g : u, a)
    );
  }, k = (a) => m(a.matches);
  N(
    () => {
      if (i)
        return i.addEventListener("change", k), () => {
          i && i.removeEventListener("change", k);
        };
    },
    []
  );
  const E = {
    isDark: o,
    isLight: !o,
    setDark: () => m(!0),
    setLight: () => m(!1),
    setIsDark: C,
    toggleTheme: () => m(!o),
    theme: o ? g : u,
    variant: d,
    setVariant: M
  };
  return /* @__PURE__ */ n(S.Provider, { value: E, children: s });
}, S = P(U), f = () => R(S), J = ({
  sunrise: t = {},
  nightfall: e = {}
}) => {
  const { isLight: s, setLight: c, setDark: r } = f();
  return s ? /* @__PURE__ */ n(j, { onClick: r, ...t }) : /* @__PURE__ */ n(Z, { onClick: c, ...e });
};
export {
  S as Context,
  D as Icon,
  V as Moon,
  U as NULL_CONTEXT,
  Z as Nightfall,
  $ as Sun,
  j as Sunrise,
  T as Switcher,
  z as ThemeProvider,
  J as Toggle,
  f as useTheme
};
